// extracted by css-extract-rspack-plugin
export default {"root":"sakquJ","left":"U0xcKW","right":"lZJW50"};